import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Trans } from 'react-i18next';

import { userPermissions } from '/business/shared/util/Statics';

import Button from '/shared/components/widgets/button/Button';
import LinkButton from '/shared/components/widgets/button/LinkButton';
import getAuthRuleSelector from '/business/shared/state/selectors/auth/getAuthRuleSelector';
import ChevronLeftIcon from '/shared/images/icons/icon-chevron-left-neon-green.svg';

import StyledHeaderSubNavMenu from '/business/shared/components/widgets/header/__styled__/StyledHeaderSubNavMenu';
import StyledHeaderSubNavActions from '/business/shared/components/widgets/header/__styled__/StyledHeaderSubNavActions';

import PersonIcon from '/shared/images/icons/bp-people-one-white.svg';
import LogoutIcon from '/shared/images/icons/bp-logout-white.svg';
import ReportingIcon from '/business/shared/images/icons/bp-graph-white.svg';
import type { RootState } from '/business/shared/state/store';

type HeaderDashboardSubNavMenuProps = {
  showBack?: boolean;
};

function HeaderDashboardSubNavMenu({ showBack = false }: HeaderDashboardSubNavMenuProps) {
  const reportingDashboardAuth = useSelector((state: RootState) =>
    getAuthRuleSelector(state, userPermissions.VIEW_REPORTING_DASHBOARD),
  );
  const navigate = useNavigate();

  return (
    <StyledHeaderSubNavMenu>
      {showBack && (
        <StyledHeaderSubNavActions $isAlignedLeft>
          <div>
            <LinkButton
              $secondary
              $small
              $icon={ChevronLeftIcon}
              onClick={() => {
                navigate('/');
              }}
            >
              {/* @i18n: Back to dashboard */}
              <Trans i18nKey="business:Buttons.linkDashboardBack" />
            </LinkButton>
          </div>
        </StyledHeaderSubNavActions>
      )}
      <StyledHeaderSubNavActions $isAlignedRight>
        <div>
          <LinkButton
            $secondary
            $small
            $icon={PersonIcon}
            onClick={() => {
              navigate('/my-profile');
            }}
          >
            {/* @i18n: My profile */}
            <Trans i18nKey="business:Buttons.linkProfile" />
          </LinkButton>
        </div>
        {reportingDashboardAuth && (
          <div>
            <LinkButton
              $secondary
              $small
              $icon={ReportingIcon}
              onClick={() => {
                navigate('/reporting');
              }}
            >
              {/* @i18n: Reporting */}
              <Trans i18nKey="business:Buttons.linkReporting" />
            </LinkButton>
          </div>
        )}
        <div>
          <Button
            $secondary
            $small
            $icon={LogoutIcon}
            onClick={() => {
              navigate('/sso/logout');
            }}
          >
            {/* @i18n: Log out */}
            <Trans i18nKey="business:Buttons.linkLogout" />
          </Button>
        </div>
      </StyledHeaderSubNavActions>
    </StyledHeaderSubNavMenu>
  );
}

export default HeaderDashboardSubNavMenu;
